export const getAssetsBaseUrl = (): string =>
    process.env.REACT_APP_IMAGES_URL ?? '';
